/**
 * Toast Configuration - Design System V4.0
 * Modern, clean toast notifications with design system colors
 */
const toastConfig = {
  position: 'top-right',
  autoClose: 4000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  className: 'toast-custom',
};

// Success toast config override
export const toastSuccessConfig = {
  ...toastConfig,
  className: 'toast-custom toast-success',
};

// Error toast config override
export const toastErrorConfig = {
  ...toastConfig,
  className: 'toast-custom toast-error',
};

// Warning toast config override
export const toastWarningConfig = {
  ...toastConfig,
  className: 'toast-custom toast-warning',
};

// Info toast config override
export const toastInfoConfig = {
  ...toastConfig,
  className: 'toast-custom toast-info',
};

export default toastConfig;
